

import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect } from 'react-router-dom'
import { register } from './UserFunctions'
import logo from './lo.png';
import Navbar from './Navbar';
import Axios from 'axios';


const validEmailRegex = RegExp(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i);
const validateForm = (errors) => {
  let valid = true;
  Object.values(errors).forEach(
    (val) => val.length > 0 && (valid = false)
  );
  return valid;
}


class RegForm extends Component {
      constructor() {
        super()
        this.state = { 
          id: '',
          firstname: '',
          lastname: '',
          email: '',
          password: '',
          note:'',
          zipfile:'',
          imagescounts: '',
          imagesframe:'',
          username: '',
          zipfile:'',
          errors: {
            firstname: '',
            email: '',
            password: '',
          }
        }
    
        this.onChange = this.onChange.bind(this)
        this.onSubmit = this.onSubmit.bind(this)
      }

      componentDidMount(){
       console.log(this.props.location.state.id)
       const id = this.props.location.state.id
         

      const zipfile = Axios.get(`https://apis.pixelbyhand.com/images/api/${id}`)
      .then(res=> {
        
        // console.log(JSON.stringify(res.data))
        const zipfile = JSON.stringify(res.data[0])
        let jsonObj = JSON.parse(zipfile);
        const newzip = jsonObj.zipfile
        console.log(newzip)
        this.setState({zipfile:newzip})

        const email = JSON.stringify(res.data[0].email)
        const email1 = jsonObj.email
        console.log(email1)
        this.setState({email:email1})
        
        const note = JSON.stringify(res.data[0].note)
        const note1 = jsonObj.note
        console.log(note1)
        this.setState({note:note1})

       })
      
      }
    
      onChange(e) {
        e.preventDefault();
    const { name, value } = e.target;
    let errors = this.state.errors;

    switch (name) {
      case 'firstname': 
        errors.firstname = 
          value.length < 3
            ? 'First Name must be 3 characters long!'
            : '';
        break;
      case 'email': 
        errors.email = 
          validEmailRegex.test(value)
            ? ''
            : 'Email is not valid!';
        break;
      case 'password': 
        errors.password = 
          value.length < 8
            ? 'Password must be 8 characters long!'
            : '';
        break;
      default:
        break;
    }

    this.setState({errors, [name]: value});
      }
    
    
    
    
      onSubmit(e) {
        e.preventDefault()

    
        const newUser = {
          id :  this.props.location.state.id,
          firstname: this.state.firstname,
          lastname: this.state.lastname,
          email: this.state.email,
          password: this.state.password,
          imagescounts: this.state.imagescounts,
          imagesframe:this.state.imagesframe,
          note: this.state.note,
          zipfile: this.state.zipfile
          
        }
    
        console.log(newUser)

        register(newUser).then(res => {
          if(validateForm(this.state.errors)) {
            console.info('Valid Form')
            // this.props.history.push(`https://pixelbyhand.com/thankyou`)
            window.location.href = "https://www.pixelbyhand.com/thank-you-ads/";
            //this.props.history.push(``)
          }else{
            console.error('Invalid Form')
            
          }
          
        })


        
        

       // localStorage.clear();
      }
    
      render() {
        const {errors} = this.state;
        
        

  

        return (
          <div className="boxer">
            <Navbar/>
           
          <div className="container">
           
            <div className="row">
            
              <div className="col-md-10  mx-auto">
  
              
                <form  onSubmit={this.onSubmit} className="regfform">
                   <h1 className="logh1">Complete Your Free Trial Signup</h1>
                  
                  <div className="row">

                  <input
                     type="text"
                     className="form-control"
                     name="zipfile"
                     type="hidden"
                     value={this.state.zipfile}
                     onChange={this.onChange}
                   />

                  <div className="form-group col-md-6" >
                   
                   <input
                    
                     className="form-control"
                     name="id"
                    
                     type="hidden"
                     value={this.props.location.state.id}
                     
                   />
                 </div>


                  <div className="form-group col-md-6" >
                   
                    <input
                      type="text"
                      className="form-control"
                      name="note"
                      type="hidden"
                      
                      value={this.state.note}
                      onChange={this.onChange}
                    />
                  </div>


                  <div className="form-group col-md-6">
                    <label htmlFor="firstname">First Name</label>
                    <input
                      type="text"
                      required
                      className="form-control"
                      name="firstname"
                      noValidate
                      placeholder="Enter Your First Name"
                      value={this.state.firstname}
                      onChange={this.onChange}
                    />
                    {errors.firstname.length > 0 && 
                <span className='passinfo error'>{errors.firstname}</span>}
                  </div>
                  <div className="form-group col-md-6">
                    <label htmlFor="lastname">Last Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="lastname"
                      required
                      placeholder="Enter Your Last Name"
                      value={this.state.lastname}
                      onChange={this.onChange}
                    />
                  </div>


                 


                  </div> 

                 

                  
     <div className="row">
                  <div className="form-group col-md-12">
                    <label htmlFor="imagescounts">HOW MANY PRODUCT IMAGES DO YOU EDIT PER YEAR?</label>
                    <select className="custom-select" id="imagescounts" name="imagescounts" type="selected"
                        value={this.state.imagescounts}
                        required
                        onChange={this.onChange}>
                    
                    <option>Choose...</option>
                    <option>Less than 1,000</option>
                    <option >1,000 - 5,000</option>
                    <option >2,500 - 10,000</option>
                    <option>10,000 - 50,000</option>
                    <option>50,000 - 250,000</option>
                    <option>More than 250,000</option>
                    </select>
                  </div>



                  <div className="form-group col-md-12">
            <label htmlFor="imagesframe">HOW OFTEN DO YOU EDIT PRODUCT IMAGES?</label>
              <select 
                   className="custom-select" 
                   id="imagesframe"
                   name="imagesframe"
                   type="select"
                   value={this.state.imagesframe}
                   required
                   onChange={this.onChange}>
                   
                     <option selected>Choose...</option>
                     <option>Annually</option>
                     <option>Semi-Annually</option>
                     <option>Quarterly</option>
                     <option>Monthly</option>
                     <option>Daily</option>
                     <option>One-time batch</option>
                </select>
                </div>

                </div>

                 

                <div className="row">

<div className="form-group col-md-6">
  <label htmlFor="email">Email Address</label>
  <input
    type="email"
    className="form-control"
    name="email"
    disabled
    
    placeholder="Enter Your E-mail"
    value={this.state.email}
    onChange={this.onChange}
  />
</div>

<div className="form-group col-md-6">
                    <label htmlFor="password">Password</label>
                    <input
                      type="password"
                      className="form-control"
                      name="password"
                      placeholder="Password"
                      value={this.state.password}
                      noValidate
                      onChange={this.onChange}
                    />
                     {errors.password.length > 0 && 
                <span className='passinfo error'>{errors.password}</span>}
                  </div>
                  

</div>
  
    
                  <button
                    type="submit"
                    className="btn btn-lg butt btn-primary btn-block"
                  >
                    Register!
                  </button>
                
                </form>
              </div>
            </div>
          </div>
          </div>
        )
      }
    }
    
    export default RegForm;
    